import { Button, Card, Title } from "@ui5/webcomponents-react";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function UnavailableServiceComponent() {
  const goBack = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Card className="m-20">
        <div className="draaft-front__landing-card__header m-3">
          <img
            slot="logo"
            src="https://plan-lab.dominioagil.cl/webapp/img/logo.png"
            className="draaft-front-login-image"
            alt="image"
          />
        </div>
        <div className="draaft-front__landing-card__header m-3">
          <Title level="H2" className="mb-10">
            El servicio no está disponible.
          </Title>
        </div>
        <div className="m-2">
          <Button
            design="Default"
            onClick={() => goBack(-1)}
            className="bg-green-500 text-white mb-2 w-full"
          >
            Reintentar
          </Button>
        </div>
      </Card>
    </div>
  );
}
